import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('settlement_cart_history_item_result')
export default class SettlementCartHistoryItemResult {
  constructor() {
    this.examinationDatetime = '';
    this.resultCode = '';
    this.status = '';
    this.correctRate = 0;
  }

  @JsonProperty('examination_datetime')
  public examinationDatetime: string;

  @JsonProperty('examination_result_code')
  public resultCode: string;

  @JsonProperty('status')
  public status: string;

  @JsonProperty('correct_rate')
  public correctRate: number;
}
